import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTheme } from './ThemeProvider';
/*
  The ThemeRoot is a container which converts all theme variables into CSS variables
  and attaches them to itself so all descendant components can easily access them.

  Even though JSS allows the use of props inside the style definition, every function
  that checks a prop generates a extra class for every instance of a component. So in
  order to avoid generating tons of classes at run time, components in the library limit
  themselves to use the theme variables through CSS and only use props inside the style
  definition for the theme overrides.
*/
var useStyles = createUseStyles({
    root: function (theme) { return ({
        '--RUI-color-primary-lighter': theme.palette.primary.lighter,
        '--RUI-color-primary-light': theme.palette.primary.light,
        '--RUI-color-primary': theme.palette.primary.main,
        '--RUI-color-primary-dark': theme.palette.primary.dark,
        '--RUI-color-primary-darker': theme.palette.primary.darker,
        '--RUI-color-primary-contrast': theme.palette.primary.contrast,
        '--RUI-color-secondary-lighter': theme.palette.secondary.lighter,
        '--RUI-color-secondary-light': theme.palette.secondary.light,
        '--RUI-color-secondary': theme.palette.secondary.main,
        '--RUI-color-secondary-dark': theme.palette.secondary.dark,
        '--RUI-color-secondary-darker': theme.palette.secondary.darker,
        '--RUI-color-secondary-contrast': theme.palette.secondary.contrast,
        '--RUI-color-neutral-lighter': theme.palette.neutral.lighter,
        '--RUI-color-neutral-light': theme.palette.neutral.light,
        '--RUI-color-neutral': theme.palette.neutral.main,
        '--RUI-color-neutral-dark': theme.palette.neutral.dark,
        '--RUI-color-neutral-darker': theme.palette.neutral.darker,
        '--RUI-color-neutral-contrast': theme.palette.neutral.contrast,
        '--RUI-color-success-lighter': theme.palette.success.lighter,
        '--RUI-color-success-light': theme.palette.success.light,
        '--RUI-color-success': theme.palette.success.main,
        '--RUI-color-success-dark': theme.palette.success.dark,
        '--RUI-color-success-darker': theme.palette.success.darker,
        '--RUI-color-success-contrast': theme.palette.success.contrast,
        '--RUI-color-warning-lighter': theme.palette.warning.lighter,
        '--RUI-color-warning-light': theme.palette.warning.light,
        '--RUI-color-warning': theme.palette.warning.main,
        '--RUI-color-warning-dark': theme.palette.warning.dark,
        '--RUI-color-warning-darker': theme.palette.warning.darker,
        '--RUI-color-warning-contrast': theme.palette.warning.contrast,
        '--RUI-color-error-lighter': theme.palette.error.lighter,
        '--RUI-color-error-light': theme.palette.error.light,
        '--RUI-color-error': theme.palette.error.main,
        '--RUI-color-error-dark': theme.palette.error.dark,
        '--RUI-color-error-darker': theme.palette.error.darker,
        '--RUI-color-error-contrast': theme.palette.error.contrast,
        '--RUI-color-paper-lighter': theme.palette.paper.lighter,
        '--RUI-color-paper-light': theme.palette.paper.light,
        '--RUI-color-paper': theme.palette.paper.main,
        '--RUI-color-paper-dark': theme.palette.paper.dark,
        '--RUI-color-paper-darker': theme.palette.paper.darker,
        '--RUI-color-paper-contrast': theme.palette.paper.contrast,
        '--RUI-border-width': theme.dimensions.borderWidth,
        '--RUI-border-radius': theme.dimensions.borderRadius,
        '--RUI-margin': theme.dimensions.margin,
        '--RUI-padding': theme.dimensions.padding,
        '--RUI-font-title1': theme.typography.title1,
        '--RUI-font-title2': theme.typography.title2,
        '--RUI-font-title3': theme.typography.title3,
        '--RUI-font-title4': theme.typography.title4,
        '--RUI-font-title5': theme.typography.title5,
        '--RUI-font-body1': theme.typography.body1,
        '--RUI-font-body2': theme.typography.body2,
        '--RUI-font-button': theme.typography.button,
        '--RUI-font-caption': theme.typography.caption,
        '--RUI-font-input': theme.typography.input,
        // root color and font for text with no color set
        color: 'var(--RUI-color-paper-contrast)',
        backgroundColor: 'var(--RUI-color-paper-main)',
        font: 'var(--RUI-font-body1)',
    }); },
}, { name: 'RUIRoot' });
var ThemeRoot = function (_a) {
    var children = _a.children;
    var theme = useTheme();
    var styles = useStyles(theme);
    return React.createElement("div", { className: "RUIRoot ".concat(styles.root) }, children);
};
export default ThemeRoot;
